import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ExportToPstFormBuilderService } from '@common/components/export-to-pst/export-to-pst-form-builder.service';
import { ExportToPstComponent } from '@common/components/export-to-pst/export-to-pst.component';
import { MailFilterModule } from '@common/components/export-to-pst/mail-filter/mail-filter.module';
import { I18NextModule } from 'angular-i18next';
import { AlertModule, CheckboxModule, FormGroupModule } from 'mbs-ui-kit';

@NgModule({
  imports: [AlertModule, CheckboxModule, FormGroupModule, I18NextModule, MailFilterModule, NgIf, ReactiveFormsModule],
  declarations: [ExportToPstComponent],
  exports: [ExportToPstComponent],
  providers: [ExportToPstFormBuilderService]
})
export class ExportToPstModule {}
